import React from "react";

export default class extends React.Component {
  render() {
    const { setting } = this.props;
    const headerSetting = setting ? setting["header"] : undefined;

    if (headerSetting === "none") {
      return null;
    }

    if (headerSetting === "thin") {
      return <dwc-mini-header theme="dark" thin container="small" />;
    }

    if (headerSetting == "developer") {
        return <dwc-header />
    }

    return (<dwc-header theme="dark" thin container="small" />);
  }
}

